// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as FareEstimateResultCallBackRequestApiModel$PorterinFeature from "../api-model/FareEstimateResultCallBackRequestApiModel.mjs";

function apiModelToState(model) {
  return {
          status: model.status,
          response: model.response
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(FareEstimateResultCallBackRequestApiModel$PorterinFeature.t_decode(json), "FareEstimateResultCallbackRequestEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
